<template>
	<div>
		<template v-if="dataList.length">
			<van-list
				v-model="loading"	
				:finished="finished"
				:immediate-check="false"
				finished-text="没有更多了"
				@load="onLoad"
				:offset="10"
			>
				<div class="videoList flex flex-align-center flex-jus-between flex-wrap">
					<div class="videoItem" v-for="item in dataList" :key="item.id">
						<videoItem :cover="item.pic" :width="167" :height="111" :id="item.id" :content="item.title" :videoSrc="item.video"></videoItem>
					</div>
				</div>
			</van-list>
		</template>
		<template v-else>
			<div class="empty">
				<div class="empty-img">
					<img src="@/static/images/index/emptySearch.png" alt="">
				</div>
				<div class="empty-text">暂无相关资源</div>
			</div>
		</template>
	</div>
</template>

<script>
import videoItem from '@/views/components/videoItem.vue';
/* eslint-disable */
export default {
	components: {
		videoItem
	},
	data() {
		return {
			page: 1,
			loading: false,
      finished: false,
      dataList: []
		};
	},
	props: {
    search_text: {
      type: String,
      default: ''
    }
  },
	mounted() {},
	methods: {
		getList() {
			this.$get('api/index/search', {
				type: 3,
				search_text: this.search_text,
				pageSize: 10,
				page: this.page
			}).then(res => {
				this.loading = false;
        let rows = res.data;
        if (rows == null || rows.length === 0) {
          this.finished = true;
          return;
        }
        this.dataList.splice((this.page - 1) * 10, 10, ...rows)

			})
		},
		onLoad() {
			this.page++;
      if (this.page > 1) {
        this.getList();
      }
		},
	}
};
</script>

<style scoped lang="stylus">
.selectCenter
	margin 0 auto
	width 160px
	height 64px
	border 2px solid #FFFFFF
	border-radius 38px
	font-size 28px
	color #FFFFFF
	img
		margin-left 8px
		width 12px
		height 22px
.videoList
	padding 24px 30px
	.videoItem
		margin-bottom 28px
.empty
	background-color inherit
	.empty-img
		margin 280px auto 0 auto
		width 373px
		height 320px
		img
			width 100%
			height 100%
	.empty-text
		width 100%
		text-align center
		margin-top 22px
		font-size: 26px;
		color: #111111;
</style>
